import { configureStore } from "@reduxjs/toolkit";

import APPReducer from "./APP";
import TREEReducer from "./TREE";
import MAPReducer from "./MAP";
import MAINReducer from "./MAIN";
import TABLEReducer from "./TABLE";
import CHARTSReducer from "./CHARTS";
import AccordionReducer from "./Accordion";

export default configureStore({
    reducer: {
        APP: APPReducer,
        TREE: TREEReducer,
        MAIN: MAINReducer,
        MAP: MAPReducer,
        TABLE: TABLEReducer,
        CHARTS: CHARTSReducer,
        Accordion: AccordionReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }),
});
